import React from 'react';

import cn from 'classnames';

import styles from './AlertBox.module.css';

export type AlertBoxProps = {
  variant?: 'success' | 'failure' | 'cancel' | 'connect';
  children?: React.ReactNode;
  className?: string;
};

export const AlertBox = ({
  variant = 'success',
  children,
  className,
  ...alertProps
}: AlertBoxProps) => {
  return (
    <div
      role="alert"
      className={cn(styles.alertBox, styles[variant], className)}
      {...alertProps}
    >
      {children}
    </div>
  );
};

AlertBox.displayName = 'AlertBox';
